import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { ColorMode } from "@/theme";

interface ColorModeState {
  mode: ColorMode;
  toggle: () => void;
  setMode: (mode: ColorMode) => void;
}

export const useColorMode = create<ColorModeState>()(
  persist(
    (set, get) => ({
      // Light is the default on first load; an explicit toggle persists and wins.
      mode: "light",
      toggle: () => set({ mode: get().mode === "dark" ? "light" : "dark" }),
      setMode: (mode) => set({ mode }),
    }),
    { name: "invmgmt-color-mode" }
  )
);
